import { useUser } from "auth";
import { Box } from "components/Box";
import Button from "components/Button";
import Loader from "components/Loader";
import { Panel } from "components/Panel";
import { Text } from "components/Text";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import styled, { useTheme } from "styled-components";
import liftoffSrc from "../../img/liftoff.jpg";

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${(props) => props.theme.colors.grey0};
  padding: 12px;
`;

const Logo = styled.img`
  margin-bottom: 36px;
  margin-top: 36px;
  width: 200px;
  max-width: 100%;
`;

const LiftOff = styled.img`
  max-width: 100%;
`;

const ConfirmEmail = () => {
  const [done, setDone] = useState(false);
  const theme = useTheme();
  const { code } = useParams<{ code: string }>();
  const { confirmEmail } = useUser();

  useEffect(() => {
    if (!done) {
      confirmEmail(code).then(() => {
        setDone(true);
      });
    }
  }, [code, done, confirmEmail]);

  return (
    <Container>
      <Logo src={theme.logo} />
      <Panel p={0} width={600}>
        {!done ? (
          <Loader />
        ) : (
          <>
            <LiftOff src={liftoffSrc} />
            <Box p={3}>
              <Text
                as="h1"
                fontSize={6}
                textAlign="center"
                mb={3}
                fontWeight={600}
              >
                Thank you!
              </Text>
              <Box pl={[2, 5]} pr={[2, 5]}>
                <Text mb={1} fontSize={4}>
                  Thanks for confirming your email address, we know you won't
                  regret it.
                </Text>
                <Text mb={5} fontSize={4}>
                  Click the button below to start your new, more productive,
                  more successful life.
                </Text>
              </Box>
              <Box style={{ textAlign: "center" }} mb={3}>
                <Button to="/" large ml="auto" mr="auto">
                  Continue to the schedule
                </Button>
              </Box>
            </Box>
          </>
        )}
      </Panel>
    </Container>
  );
};

export default ConfirmEmail;
